var React = require('react');

function ArrowUpSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.469 15.323L12.969 2.18l-11.5 13.143","strokeWidth":"3","stroke":"#0B0B0A","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowUpSmall.defaultProps = {"width":"26","height":"17","viewBox":"0 0 26 17"};

module.exports = ArrowUpSmall;

ArrowUpSmall.default = ArrowUpSmall;
